import React from 'react'
import './thankyou.styles.scss'
import { ReactComponent as FireWorks } from '../../Assets/fireworks.svg'
import { Button } from '@mui/material'
import { useNavigate } from 'react-router'

const ThankYou = () => {
    const navigate = useNavigate();

    return (
        <div className='thx' aria-label="Schermata di ringraziamento">
            <FireWorks aria-label="Animazione fuochi d'artificio" />
            <label className='title' aria-label="Grazie per aver inviato la richiesta">
                Grazie per aver inviato la richiesta
            </label>
            <label className='subtitle' aria-label="Il nostro team ti contatterà presto">
                Il nostro team ti contatterà presto!
            </label>
            <Button
                variant="contained"
                style={{ backgroundColor: '#416D03' }}
                onClick={() => navigate('home')}
                aria-label="Torna alla home"
            >
                Torna alla home
            </Button>
        </div>
    )
}

export default ThankYou